import { combineReducers } from 'redux';
import { RECEIVE_MONETICO_FORMDATA, REQUEST_PAYMENT } from './constants';

const moneticoFormData = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_MONETICO_FORMDATA:
            return {
                ...action.response.payload,
                moneticoFormDataState: 'ready',
                moneticoPaymentOnGoing: false
            };
        default:
            return state;
    }
};

const moneticoPaymentOnGoing = (state = false, action) => {
    switch (action.type) {
        case REQUEST_PAYMENT:
            return action.payload;
        default:
            return state;
    }
};

export default combineReducers({ moneticoFormData, moneticoPaymentOnGoing });



// WEBPACK FOOTER //
// ./src/services/monetico/reducer.js